import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useState } from "react";
import UserTable from "./UserTable";
import PdfTable from "./PdfTable";
import useFetching from "../../utils/Fetching";
import StepEditor from "../editor/StepEditor";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const AdminTabPanel = () => {
  const [value, setValue] = useState(0);
  const { saveStepData } = useFetching();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="Admin Panel">
          <Tab label="Nutzerübersicht" {...a11yProps(0)} />
          <Tab label="Dateien" {...a11yProps(1)} />
          <Tab label="Editor" {...a11yProps} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className="table-section">
          <div className="pdf-header">Nutzer:</div>
          <UserTable />
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className="table-section">
          <div className="pdf-header">Dokumente anpassen:</div>
          <PdfTable />
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <StepEditor />
      </CustomTabPanel>
    </Box>
  );
};

export default AdminTabPanel;
